// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EmitMessages {
  export enum MessageTypes {
    // Action = 'emit.action',
    Ready = 'emit.ready',
    UpdateState = 'emit.updateState',
  }

  export class UpdateState {
    readonly type = MessageTypes.UpdateState;

    constructor(public readonly diff: any) {}
  }

  // export class Action {
  //   readonly type = MessageTypes.Action;

  //   constructor(public readonly action: EmbedBuilderActions.Actions) {}
  // }

  export class Ready {
    readonly type = MessageTypes.Ready;
    constructor(public readonly id: string) {}
  }
}
